import {createContext, useReducer} from "react";
import ConfirmModal from "../components/ConfirmModal";
import useAlerts from "../hooks/useAlerts";

let actionPromise = null;
let lastPromise = null;
const initialModalConfig = {open: false};

const SET_MODAL_ACTION = 'set-action';
const RESET_MODAL_ACTION = 'reset-action';

function configReducer(state, action) {
    switch (action.type) {
        case SET_MODAL_ACTION: {
            const {payload} = action;
            return {
                open: true,
                content: payload.content,
                titleText: payload.titleText,
                confirmText: payload.confirmText
            };
        }
        case RESET_MODAL_ACTION:
            return {...initialModalConfig};
        default:
            throw new Error('Azione della modale non valida');
    }
}

function createConfigPayload(content, titleText, confirmText) {
    return {content, titleText, confirmText};
}

export const ConfirmModalContext = createContext('confirmModal');
export function ConfirmModalProvider({children}){
    const [modalConfig, dispatchConfigAction] = useReducer(configReducer, initialModalConfig);
    const dispatchAlert = useAlerts();

    const askConfirm = (modalAction, {titleText, confirmText} = {}) => {
        if (null === lastPromise) {
            lastPromise = new Promise(resolve => {
                actionPromise = {
                    resolve: () => resolve(true),
                    reject: () => {
                        resolve(false);
                        dispatchAlert('Operazione annullata', {variant: 'info'});
                    }
                }
            });

            lastPromise.finally(() => {
                actionPromise = null;
                lastPromise = null;
                dispatchConfigAction({type: RESET_MODAL_ACTION});
            })
        }

        dispatchConfigAction({type: SET_MODAL_ACTION, payload: createConfigPayload(modalAction, titleText, confirmText)});

        return lastPromise;
    };



    return (
        <ConfirmModalContext.Provider value={{askConfirm}}>
            {children}
            <ConfirmModal
                open={modalConfig.open}
                onConfirm={() => actionPromise?.resolve()}
                onDeny={() => actionPromise?.reject()}
                confirmText={modalConfig.confirmText}
                titleText={modalConfig.titleText}
            >
                {modalConfig.content}
            </ConfirmModal>
        </ConfirmModalContext.Provider>
    );
}

